import { FEATURE_NAMES } from '../../features/constants';

export const heaviestResources = {
  enabled: false,
  auto_instrument: false,
  harvester: true,
  sampling: 1.0,
  features_required: [FEATURE_NAMES.sessionTrace],
  mapped_attributes: {
    fileSupport: {
      img: [
        'apng',
        'avif',
        'gif',
        'jpg',
        'jpeg',
        'jfif',
        'pjpeg',
        'pjp',
        'png',
        'svg',
        'webp',
      ],
      script: ['js'],
      style: ['css'],
    },
    thresholdEntries: {
      img: 250000,
      script: 170000,
      style: 50000,
    },
  },
};
